import React from 'react';
import { Grid, Text, Flex, Image } from '@chakra-ui/react';
import { TypeDTO } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { selectTypesList } from '../../../modules/catalog/selectors';
import { setCarTypeAction } from '../../../modules/catalog/actions';

export const BrandsGrid: React.FC = () => {
  const dispatch = useAppDispatch();
  const typesList = useAppSelector(selectTypesList);

  if (!typesList) return null;

  const sortedBrands = [...typesList].sort((a, b) => a.name.localeCompare(b.name));

  const groupedBrands = sortedBrands.reduce((acc: { [key: string]: TypeDTO[] }, brand) => {
    const firstLetter = brand.name.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(brand);
    return acc;
  }, {});

  const handleBrandClick = (brandId: string) => {
    dispatch(setCarTypeAction(brandId));
  };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={10}>
      {Object.entries(groupedBrands).map(([letter, brands]) => (
        <Flex key={letter}>
          <Text paddingRight="12px" paddingTop="5px" fontWeight="bold" fontSize="xl" mb={2}>
            {letter}
          </Text>
          <Flex direction="column" mb={5}>
            {brands.map(brand => (
              <Flex
                key={brand.id}
                cursor="pointer"
                mb={3}
                flexDir="column"
                onClick={() => handleBrandClick(brand.id)}
              >
                <Image src={brand.image} width="50px" />
                <Text>{brand.name}</Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      ))}
    </Grid>
  );
};
